var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.onClick}},[_c('svg-icon',{attrs:{"icon-name":_vm.isFullscreen ? 'screen-out' : 'screen-in',"icon-class":_vm.iconClass}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }